import React from 'react';

import { IRouter } from '@routers/interface';

export const routerVoucherInfo: IRouter = {
  path: '/voucher-type/info/:id',
  loader: React.lazy(() => import('./index')),
  exact: true,
  masterLayout: true,
  name: 'voucher-info.router.name', //translate here for breadcrumb and sidebar
};
